import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import SahamDrawer from 'components/SahamDrawer';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/messages';
import judgementAddMessages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { translate } from 'containers/services/translate';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { Listings } from 'containers/AppContainer/typings';
import { JudgementAddFormDrawerStyle } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/styled-components';
import {
  CorporealDocument,
  ExpertiseState,
  JudgementADDDocumentType,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { EMPTY_EXPERTISE } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { cloneDeep, get, isEmpty } from 'lodash';
import JudgementAddFormFields from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/JudgementAddFormFields';
import ExpertiseForm from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/ExpertiseForm';
import { LISTINGS } from 'containers/data-structure';
import { formattedJudgementAddPronouncing } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/utils';
import { FIELDS_TO_UPDATE } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/constants';
import { shouldValidateJudgementPronouncing } from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/form-validation';
import {
  extractVictimIdFromJom,
  formatExpertiseState,
} from 'containers/CourtManagerLegalProceedings/JudgementAdd/Drawers/utils';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { EMPTY_SUPPORT_DOC } from 'containers/LawyerRecapPage/constants';
import { DOCUMENT_TYPES } from 'constants/global';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { VictimType } from 'typings/globalTypes';
export interface AppealAddPronouncingDrawerProps {
  intl: IntlShape;
  open: boolean;
  handleToggleDrawer: Function;
  victims: VictimType[];
  vehicules: Vehicule[];
  setJudgementAdd: Function;
  index: number;
  judgementAddExpertises: JudgementADDDocumentType[];
  setJudgementAddExpertises: Function;
  listings: Listings;
  details: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  judgementAddDocumentsStore: JudgementADDDocumentType[];
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  judgementOnMerits: any;
}

const AppealAddPronouncingDrawer: React.FC<AppealAddPronouncingDrawerProps> = (
  props,
): JSX.Element => {
  const [canSaveJuddgementDocument, setCanSaveJudgementDocument] = useState<
    boolean
  >(false);

  const [expertises, setExpertises] = useState<ExpertiseState[]>([]);

  useEffect(() => {
    const formattedExpertises = formatExpertiseState(
      get(props.judgementAddExpertises[props.index], 'expertises', []),
    );
    if (isEmpty(formattedExpertises)) {
      setExpertises([cloneDeep(EMPTY_EXPERTISE)] as any);
    } else {
      setExpertises(cloneDeep(formattedExpertises));
    }
  }, [props.index, props.judgementAddExpertises]);

  useEffect(() => {
    setCanSaveJudgementDocument(
      shouldValidateJudgementPronouncing(
        props.judgementAddExpertises[props.index],
        expertises,
      ),
    );
  }, [props.judgementAddExpertises, expertises, props.index]);
  const handleSetExpertise = (index: number) => (value: ExpertiseState) => {
    const expertisesAdd = [...expertises];
    expertisesAdd[index] = value;

    setExpertises(expertisesAdd);
  };

  const handleSetJudgementAddPronouncing = (index: number) => (
    value: JudgementADDDocumentType,
  ) => {
    const documents = [...props.judgementAddExpertises];
    documents[index] = { ...value, isUpdated: true };

    props.setJudgementAddExpertises(documents);
  };

  const handleSaveJudgementAdd = () => {
    const documents = [...props.judgementAddExpertises];
    const currentDocumentStore =
      props.judgementAddDocumentsStore &&
      props.judgementAddDocumentsStore.find(
        item => item.id === documents[props.index]?.id,
      );
    documents[props.index] = formattedJudgementAddPronouncing(
      expertises,
      props.victims,
      props.vehicules,
      props.judgementAddExpertises[props.index],
      currentDocumentStore,
    );

    props.setJudgementAdd(FIELDS_TO_UPDATE.JUDGEMENT_PRONOUNCING, documents);
    props.handleToggleDrawer();
  };
  const [judgementAddDocument, setJudgementAddDocument] = useState({
    ...EMPTY_SUPPORT_DOC,
  });
  /* istanbul ignore next */
  const setUploadJudgementAddDocument = (document: CorporealDocument) => {
    const judgementAdd = {
      ...props.judgementAddExpertises[props.index],
      ...document,
    };
    handleSetJudgementAddPronouncing(props.index)(judgementAdd);
    setJudgementAddDocument(document);
  };
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={props.handleToggleDrawer}
      title={translate(judgementAddMessages.appealAddPronouncingTitle, props)}
      confirmButtonTitle={translate(messages.save, props)}
      handleValidateDrawer={handleSaveJudgementAdd}
      isSaveButtonDisabled={!canSaveJuddgementDocument}
    >
      <JudgementAddFormDrawerStyle>
        <JudgementAddFormFields
          index={props.index}
          handleSetJudgementAddPronouncing={handleSetJudgementAddPronouncing(
            props.index,
          )}
          judgementAddPronouncing={props.judgementAddExpertises[props.index]}
          listings={props.listings}
          details={props.details}
          hearingDate={get(props.details, 'hearingDate', '')}
        />
        <section className="expertise-bloc">
          <div className="expertise-title">Expertise</div>
          {!isEmpty(expertises) &&
            expertises.map((expertise, index: number) => (
              <ExpertiseForm
                key={index}
                expertisesListing={get(props.listings, LISTINGS.EXPERTISE, [])}
                victims={props.victims}
                vehicules={props.vehicules}
                expertise={expertise}
                handleSetExpertise={handleSetExpertise(index)}
                index={index}
                canEdit={isEmpty(
                  get(
                    props.judgementAddExpertises[props.index],
                    'expertises',
                    [],
                  ),
                )}
                judgementAddPronouncing={
                  props.judgementAddExpertises[props.index]
                }
                sagisVictimInfo={props.sagisVictimInfo}
                sagisOpposingParties={props.sagisOpposingParties}
                victimIdsJom={extractVictimIdFromJom(props.judgementOnMerits)}
              />
            ))}
        </section>
        <section>
          <UploadDocumentBloc
            document={judgementAddDocument}
            setDocument={setUploadJudgementAddDocument}
            index={1}
            resetUploadedDocument={props.resetUploadedDocument}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            docType={DOCUMENT_TYPES.JUDGEMENT_ADD}
          />
        </section>
      </JudgementAddFormDrawerStyle>
    </SahamDrawer>
  );
};

export default injectIntl(AppealAddPronouncingDrawer);
